import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import STATIC_ROUTES from "./misc/Static_routes";
import Layout from "./components/Layout/Layout/Layout";
import LayoutEditor from "./components/Layout/Layout/LayoutEditor";
import {
  Authentication,
  userRoles,
} from "./components/Authentication/RouteGuards";

// Pages
import Home from "./pages/Home/Home";
import Test from "./pages/Test/Test";
import City from "./pages/City/City";
import NotFound from "./pages/NotFound/NotFound";
import Pin from "./pages/Pin/Pin";
// import Admin from "./pages/Admin/Admin";

import Login from "./pages/Login/Login";
import CreateDesign from "./pages/Design/CreateDesign/CreateDesign";
import SingleDesign from "./pages/Design/SingleDesign/SingleDesign";
import ErrorBoundary from "./misc/ErrorBoundary";
import CircleLoading from "./components/misc/CircleLoading/CircleLoading";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

const Admin = React.lazy(() => import("./pages/Admin/Admin"));
const AdminCity = React.lazy(() => import("./pages/Admin/City/AdminCity"));

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter basename="/app">
      <ScrollToTop />
        <Suspense
          fallback={
            <p className="loading">
              <CircleLoading />
            </p>
          }
        >    
          <Routes>
            <Route path={STATIC_ROUTES.home} element={<Layout />}>
              <Route index path={STATIC_ROUTES.home} element={<Home />} />
              <Route path={STATIC_ROUTES.test} element={<Test />} />
              <Route path={STATIC_ROUTES.city} element={<City />} />
              <Route path={STATIC_ROUTES.pin} element={<Pin />} />
              <Route
                path={STATIC_ROUTES.single_design}
                element={<SingleDesign />}
              />
              <Route
                path={STATIC_ROUTES.create_design}
                element={<CreateDesign />}
              />
              <Route path={STATIC_ROUTES.login} element={<Login />} />
              <Route path={STATIC_ROUTES.not_found} element={<NotFound />} />
            </Route>
            {/* <Route path={STATIC_ROUTES.home} element={<LayoutEditor />}>
              
            </Route> */}
            <Route path={STATIC_ROUTES.admin} element={<Layout />}>
              <Route
                index
                path={STATIC_ROUTES.admin}
                element={Authentication(Admin, [userRoles.superAdmin])}
              />
              <Route
                path={STATIC_ROUTES.city_in_admin}
                element={Authentication(AdminCity, [
                  userRoles.admin,
                  userRoles.superAdmin,
                ])}
              />
              <Route path={STATIC_ROUTES.not_found} element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
